import { User } from '@typing/global';
import axios from 'axios';
import envConfig from '../../environment';
import storage from '@utils/storage';

export type ChangePassword = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export const getUser = (): Promise<User> => {
  const user = storage.getUser(); // get user from local storage
  const userId = user?.user?.userId;

  if (!userId) {
    return Promise.reject(new Error("User ID is missing from storage"));
  }

  return axios.get(`${envConfig.apiUrl}/user/user-details/${userId}`, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const updateUser = (payload: any): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/user/update-user`, payload, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const uploadProfileImage = (payload: FormData): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/user/profile-image`, payload, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};

export const changePassword = (data: ChangePassword): Promise<User> => {
  return axios.put(`${envConfig.apiUrl}/user/change-password`, data, {
    headers: {
      authorization: `Bearer ${storage.getToken()}`,
      Accept: 'application/json',
    },
  });
};
